import { useHash } from "./useHash";
import { useEffect } from "react";
import { authStore } from "../../stores/AuthStore";

// Used for local development -> redirect after login on other environment
export const useLocalCredentials = () => {
    const credentials: { access_token: string; refresh_token: string } = useHash();

    useEffect(() => {
        const handover = async () => {
            authStore.credentials = { ...credentials, expires_in: 1000 };

            // Strip hash from url and do a proper refresh instead of just changing the url
            // Like that it's the same as doing a refresh with the new credentials
            const location = window.location;
            const target = location.origin + location.pathname + location.search;
            setTimeout(() => window.open(target, "_self"), 500);
        };

        if (credentials.access_token && credentials.access_token !== authStore.credentials?.access_token) {
            handover();
        }
    }, [credentials]);

    return !!credentials.access_token;
};
